import {Game} from '@tinct/web-layout';

export const KonamiCodePage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-5xl">
        <Game className="overflow-hidden rounded-2xl" />
      </div>
    </div>
  );
};
